import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';

interface Props {
  buttonIsDropdown?: boolean;
  competencyId: number;
  onRemove: () => Promise<void>;
}

const CompetenciesRemove = ({
  buttonIsDropdown = true,
  competencyId,
  onRemove
}: Props) => {
  const {
    messages,
    serverConfig: { requireReasonWhenDeletingData }
  } = useReduxState();

  const handleConfirm = async (values?: { deletionReason?: string }) => {
    let url = `/admin/competencies/${competencyId}`;

    if (values?.deletionReason) {
      const params = new URLSearchParams({
        deletionReason: values.deletionReason
      });
      url += `?${params.toString()}`;
    }

    await api.delete(url);
    await onRemove();
    return true;
  };

  return requireReasonWhenDeletingData ? (
    <ConfirmDeleteButton
      buttonIsDropdown={buttonIsDropdown}
      buttonText={messages.competenciesRemove}
      confirmText={messages.competenciesRemoveConfirm}
      confirmTitle={messages.competenciesRemove}
      id={`deletionReasonCompetency-${competencyId}`}
      onConfirm={handleConfirm}
      successMessage={messages.competenciesRemoveSuccess}
    />
  ) : (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={buttonIsDropdown}
      buttonText={messages.competenciesRemove}
      category="danger"
      confirmText={messages.competenciesRemoveConfirm}
      confirmTitle={messages.competenciesRemove}
      onConfirm={handleConfirm}
      successMessage={messages.competenciesRemoveSuccess}
    />
  );
};

export default CompetenciesRemove;
